import { useState } from "react";
import { Button, InputGroup } from "react-bootstrap";
import { loadingWrapper } from "../../utils/loadingWrapper";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import './login.css'
import '../../App.css'
import useLogin from "../../hooks/useLogin";
import LogoFNMA from "../../asset/img/FNMA.svg";
import FirstResetPassword from "../../components/modals/first-reset-modal/FirstResetModal";
import { setShowFirstResetPasswordResetModal } from "../../slice/showModalSlice";

const Login = () => {
  const [data, setData] = useState({
    username: '',
    password: ''
  });

  const [showPassword, setShowPassword] = useState(false);

  const showFirstReset = useSelector((state)=>state.showModal.showFirstResetPasswordModal);



  // MOCK

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {loading,login} = useLogin();


  const inputHandler = (event) => {
    const { name, value } = event.target
    setData((prevData) => ({ ...prevData, [name]: value }))
  }

  const checkLoginData = () => {
    return data.username.trim().length > 0 && data.password.trim().length > 0;
  }


  const loginHandler = async () => {
    if (!checkLoginData() || loading) return;
    login(
      data,
      (res) => {
        setData({ username: '', password: '' });
        navigate('/');
      },
      (err) => {
        toast.error(err||"Errore, Riprova piu tardi");
      },
      (res)=>{
        setData({ ...data, password: '' });
        dispatch(setShowFirstResetPasswordResetModal());
        toast.info("Primo accesso, cambia la password");
      }
    )
  };

  return (
    <div className="h-100 container align-items-center">
      <div className='h-100 row flex-column justify-content-center align-items-center'>
        <div className="login-logo-wrapper text-center mb-3">
          <img src={LogoFNMA} alt="FNMA" className="login-logo" />
        </div>
        <div className="col-11 col-sm-10 col-md-6 col-lg-4 align-self-center bg-light p-4 d-flex flex-column gap-4 card">

          <div className='login-title'><h4>UWB Login</h4></div>

          <div className="">
            <label>Username</label>
            <input
              type="text"
              name="username"
              className="form-control"
              placeholder="example@example.com"
              value={data.username}
              onChange={inputHandler}
              autoComplete="username"
            />
          </div>

          <div className="">
            <label>Password</label>
            <InputGroup className='inputGroup-focus'>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control"
                placeholder="Password"
                autoComplete="current-password"
                value={data.password}
                onChange={inputHandler}
              />
              <Button type="button" className="btn-pw" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"   
                    viewBox="0 0 16 16"
                  >
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-fill"       
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                  </svg>
                )}
              </Button>
            </InputGroup>
          </div>

          <Button
            type="button"
            className="btn-custom btn-green"
            disabled={!checkLoginData() || loading}
            onClick={loginHandler}              
          >
            {loadingWrapper(loading, <>Login</>)}  
          </Button>
        </div>
      </div>
      {showFirstReset &&<FirstResetPassword/>}
    </div>
  )
}

export default Login
